import { Component, ChangeDetectionStrategy, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormArray } from '@angular/forms';

import { markAsTouched, centsToDollars, dollarsToCents } from '../../utils';
import { requiredValidator } from '../../validators';

@Component({
  selector: 'app-invoice-form',
  templateUrl: 'invoice-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceFormComponent implements OnInit {
  form = new FormGroup({
    items: new FormArray([]),
  });

  @Output() onSubmit = new EventEmitter();

  ngOnInit() {
    this.addItem();
  }

  addItem() {
    this.items.push(new FormGroup({
      description: new FormControl(null, requiredValidator()),
      amount: new FormControl(null, requiredValidator()),
      tax: new FormControl(10),
      quantity: new FormControl(1, requiredValidator()),
    }));
  }

  removeItem(index: number) {
    this.items.removeAt(index);
  }

  submit() {
    if (this.form.valid) {
      const data = {
        items: this.items.value.map(item => ({
          ...item,
          amount: dollarsToCents(item.amount),
          tax: centsToDollars(item.tax || 0),
        }))
      };

      this.onSubmit.emit(data);
    } else {
      markAsTouched(this.form);
    }
  }

  get items() {
    return <FormArray>this.form.get('items');
  }

  get total() {
    return this.items.value.reduce((carry, item) => carry + (item.amount * (1 + ((item.tax || 0) / 100)) * item.quantity), 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/invoices/invoice-form.component.ts